import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { Planning } from './pages/Planning';
import { Weather } from './pages/Weather';
import { Clients } from './pages/Clients';
export function AppRouter() {
  return <BrowserRouter data-id="element-4">
      <Routes data-id="element-5">
        <Route path="/" element={<App data-id="element-7" />} data-id="element-6" />
        <Route path="/planning" element={<Planning data-id="element-9" />} data-id="element-8" />
        <Route path="/weather" element={<Weather data-id="element-11" />} data-id="element-10" />
        <Route path="/clients" element={<Clients data-id="element-13" />} data-id="element-12" />
      </Routes>
    </BrowserRouter>;
}